import React from 'react';
import './Loading.css'

import { ColorRing } from  'react-loader-spinner'
const Loading = () => {
    return (
        <div className='loader'>
            <h1 className='text-4xl font-medium text-pink-500'>Please Wait </h1>
            <br/>
           
     <div>

     <ColorRing
  visible={true}
  height="80"
  width="80"
  ariaLabel="blocks-loading"
  wrapperStyle={{}}
  wrapperClass="blocks-wrapper"
  colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
/>
     </div>
        </div>
    );
};

export default Loading;